import Icon from '../UI/Icon';
import './ContactTeaser.css';

const ContactTeaser = (): React.JSX.Element => {
  return (
    <div className="contact-teaser">
      <div className="container">
        <div className="contact-teaser-grid">
          <div className="teaser-contact-info">
            <h2>Get in Touch</h2>
            <p className="subtitle">We'd love to hear from you. Reach out to us for any questions or inquiries.</p>
            
            <div className="contact-methods">
              <div className="contact-method">
                <div className="contact-icon">
                  <Icon name="FaMapMarkerAlt" />
                </div>
                <div className="contact-details">
                  <h3>Our Location</h3>
                  <p>123 Kayamandi Main Road<br />Stellenbosch, 7600<br />Western Cape, South Africa</p>
                </div>
              </div>
              
              <div className="contact-method">
                <div className="contact-icon">
                  <Icon name="FaPhone" />
                </div>
                <div className="contact-details">
                  <h3>Contact Info</h3>
                  <p>
                    <a href="tel:+27718416784">+27 71 841 6784</a><br />
                    <a href="mailto:info@kwcdp.co.za">info@kwcdp.co.za</a>
                  </p>
                </div>
              </div>
              
              <div className="contact-method">
                <div className="contact-icon">
                  <Icon name="FaClock" />
                </div>
                <div className="contact-details">
                  <h3>Opening Hours</h3>
                  <p>
                    Monday - Friday: 8:00 AM - 5:00 PM<br />
                    Saturday: 9:00 AM - 1:00 PM<br />
                    Sunday: Closed
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="why-choose-us">
            <h3>Why Choose Us</h3>
            <p className="subtitle">We are committed to making a real difference in our community</p>
            
            <div className="features-grid">
              <div className="feature">
                <div className="feature-icon">
                  <Icon name="FaHandsHelping" />
                </div>
                <h4>Community Focused</h4>
              </div>
              
              <div className="feature">
                <div className="feature-icon">
                  <Icon name="FaUsers" />
                </div>
                <h4>Experienced Team</h4>
              </div>
              
              <div className="feature">
                <div className="feature-icon">
                  <Icon name="FaHeart" />
                </div>
                <h4>Compassionate Care</h4>
              </div>
              
              <div className="feature">
                <div className="feature-icon">
                  <Icon name="FaChartLine" />
                </div>
                <h4>Proven Impact</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactTeaser;
